<div>
  <h2> {{ 'Settings::Integration' | abpLocalization }}</h2>
</div>
<br>
<hr>
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
      <li [ngbNavItem]="1" *ngIf="isGenesysIntegrationActive">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::GenesysIntegration' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <cr-genesys-integration-settings>
          </cr-genesys-integration-settings>
        </ng-template>
      </li>
      <li [ngbNavItem]="2" *ngIf="isAmazonIntegrationActive">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::AmazonIntegration' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <cr-amazon-integration-settings>
          </cr-amazon-integration-settings>
        </ng-template>
      </li>
      <li [ngbNavItem]="3" *ngIf="isFive9IntegrationActive">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::Five9Integration' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <cr-five9-integration-settings>
          </cr-five9-integration-settings>
        </ng-template>
      </li>
      <li [ngbNavItem]="4" *ngIf="isTwilioIntegrationActive">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::TwilioIntegration' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <cr-twilio-integration-settings>
          </cr-twilio-integration-settings>
        </ng-template>
      </li>
      <li [ngbNavItem]="5" *ngIf="isNiceIntegrationActive">
        <a ngbNavLink>
          <span class="ml-1">
            {{ 'Settings::NiceIntegration' | abpLocalization }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <cr-nice-integration-settings>
          </cr-nice-integration-settings>
        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2" style="height: calc(100% - 130px)">
    </div>
